import React, { useEffect, useState } from 'react';

const Hero: React.FC = () => {
  const [text, setText] = useState('');
  const fullText = 'Aspiring Full Stack Developer & AI Enthusiast';
  const [index, setIndex] = useState(0);
  
  useEffect(() => {
    if (index < fullText.length) {
      const timer = setTimeout(() => {
        setText(prev => prev + fullText[index]);
        setIndex(index + 1);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [index, fullText]);
  
  useEffect(() => {
    // Create animated particles
    const heroSection = document.querySelector('.hero');
    if (heroSection) {
      const particles = document.createElement('div');
      particles.className = 'particles';
      
      // Create 20 particles
      for (let i = 0; i < 20; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        
        // Random size between 5-15px
        const size = Math.random() * 10 + 5;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        
        // Random position
        particle.style.left = `${Math.random() * 100}%`;
        
        // Random animation duration
        particle.style.animationDuration = `${Math.random() * 10 + 10}s`;
        
        // Random delay
        particle.style.animationDelay = `${Math.random() * 5}s`;
        
        particles.appendChild(particle);
      }
      
      heroSection.appendChild(particles);
    }
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <h1>SuryaChandra Maddha</h1>
        <p className="typing-text">{text}<span className="cursor">|</span></p>
        <a href="#about" className="btn">Learn More</a>
      </div>
    </section>
  );
};

export default Hero;